import { render, staticRenderFns } from "./StatusBox.vue?vue&type=template&id=1a2bfdc3&scoped=true"
import script from "./StatusBox.vue?vue&type=script&lang=js"
export * from "./StatusBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2bfdc3",
  null
  
)

export default component.exports